/* eslint-disable import/no-anonymous-default-export */

import qs from 'querystring';
import { AUTH_PRODUCT_TYPE } from '../constants/app-constants';
export default (api) => {

    const sendOTP = (mobile, xCountryCode = 'AE', product = AUTH_PRODUCT_TYPE) => {
        return api.get(`/oauth/${product}/otp/${mobile}`, {
            headers: {
                X_COUNTRY: xCountryCode
            }
        }
        );
    };

    const verifyOTP = (params, xCountryCode = 'AE', product = AUTH_PRODUCT_TYPE) => {
        return api.post(`/oauth/${product}/token`, qs.stringify(params), {
            headers: {
                X_COUNTRY: xCountryCode,
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    };

    const updateProfile = (firstName, email, token) => {
        return api.put('/user/me', qs.stringify({ firstName, email }), {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    };

    const getTokenInfo = (accessToken) => {
        return api.get(`oauth/v2/${AUTH_PRODUCT_TYPE}/token/refresh`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            }
        });
    };

    const getRefreshTokenInfo = (product = AUTH_PRODUCT_TYPE) => {
        return api.get(`/oauth/${product}/token/refresh`);
    };

    const logout = (params, product = AUTH_PRODUCT_TYPE) => {
        return api.get(`/oauth/${product}/logout`);
    };

    return {
        sendOTP,
        verifyOTP,
        updateProfile,
        getRefreshTokenInfo,
        logout,
        getTokenInfo
    };
};
